var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "info-all" },
        [
          _c(
            "el-aside",
            {
              staticClass: "aside-left",
              style: { height: _vm.boxHeight },
              attrs: { width: "3.20rem" }
            },
            [
              _c("p", { staticClass: "page-total" }, [
                _c("span", { staticClass: "tit" }, [_vm._v("签署文件列表")]),
                _c("span", [_vm._v("共" + _vm._s(_vm.fileList.length) + "个")])
              ]),
              _c("div", { staticClass: "aside-left_flex" }, [
                _c(
                  "div",
                  { staticClass: "page-con" },
                  [
                    _vm._l(_vm.fileList, function(file, i) {
                      return [
                        _c(
                          "div",
                          {
                            key: i,
                            staticClass: "list",
                            class: _vm.checkAct === i ? "active" : "",
                            on: {
                              click: function($event) {
                                return _vm.chooseFile(file, i)
                              }
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  placement: "right-start"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [_vm._v("此文件设置有签署位置")]
                                ),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.filePage(file),
                                      expression: "filePage(file)"
                                    }
                                  ],
                                  staticClass: "icon icon-status_sign"
                                })
                              ]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.beWord(file.fileName) ||
                                      (file.useTo && file.useTo === 1),
                                    expression:
                                      "\n                  beWord(file.fileName) || (file.useTo && file.useTo === 1)\n                "
                                  }
                                ],
                                staticClass: "tpl-icon tpl-posi",
                                staticStyle: { "z-index": "1" },
                                on: {
                                  click: function($event) {
                                    return _vm.InOnlyOffice(file, i)
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _c("div", { staticClass: "bx" }, [
                              _c("img", { attrs: { src: _vm.fileIcon(file) } })
                            ]),
                            _c(
                              "p",
                              {
                                staticClass: "title",
                                attrs: { title: file.fileName }
                              },
                              [_vm._v(_vm._s(file.fileName))]
                            )
                          ],
                          1
                        )
                      ]
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  [
                    _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "list-pages",
                          style: { height: _vm.leftCSideHeight }
                        },
                        [
                          _vm._l(_vm.contractInfoTemporary.items, function(i) {
                            return [
                              _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "listDetail",
                                  class:
                                    _vm.currentInfo.page === i ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.getContractDetailByNum(i)
                                    }
                                  }
                                },
                                [
                                  _vm.contractList[i] && _vm.contractList[i].url
                                    ? _c("img", {
                                        attrs: { src: _vm.contractList[i].url }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: "/images/contr_default.jpg",
                                          alt: ""
                                        }
                                      }),
                                  _c("span", [_vm._v(_vm._s(i))])
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  ],
                  1
                )
              ])
            ]
          ),
          _c("transition", { attrs: { name: "el-fade-in" } }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.drawerShow,
                  expression: "drawerShow"
                }
              ],
              staticClass: "aside",
              style: { height: _vm.boxHeight }
            })
          ]),
          _c("transition", { attrs: { name: "my" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.drawerShow,
                    expression: "drawerShow"
                  }
                ],
                staticClass: "aside-content",
                style: { height: _vm.boxHeight }
              },
              [
                _c("div", { staticClass: "aside-top" }, [
                  _vm._v(
                    "\n            仅供参与方查阅，不用于签署（共\n            " +
                      _vm._s(this.enclosureFilesList.length) +
                      " 份）\n            "
                  ),
                  _c("span", {
                    staticClass: "el-icon-error",
                    on: {
                      click: function($event) {
                        _vm.drawerShow = false
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    staticClass: "aside-box",
                    style: { height: _vm.windowHeight - 120 + "px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "enclosure-box" },
                      _vm._l(_vm.enclosureFilesList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "enclosure-item" },
                          [
                            _c("div", { staticClass: "li-preview" }, [
                              _vm.isImg(item) || _vm.isVideo(item)
                                ? _c("span", {
                                    staticClass: "el-icon-view",
                                    attrs: { title: "预览" },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewVideOrImg(item)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.isDoc(item)
                                ? _c("span", {
                                    staticClass: "el-icon-view",
                                    attrs: { title: "预览" },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewDoc(item)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.downloadAttatchFile(item),
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-download",
                                    attrs: { title: "下载" }
                                  })
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "li-con" }, [
                              _c("div", { staticClass: "t-do" }, [
                                _vm._v(_vm._s(_vm.getEnclosureSuffix(item)))
                              ]),
                              _c("h1", { attrs: { title: item.fileName } }, [
                                _vm._v(_vm._s(item.fileName))
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm.enclosureFilesList.length === 0
                      ? _c("no-data", {
                          attrs: { slot: "empty", text: "暂无数据" },
                          slot: "empty"
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "aside-tab",
              class: _vm.drawerShow ? "open" : "close"
            },
            [
              _c(
                "div",
                {
                  staticClass: "tab",
                  class: _vm.drawerShow ? "active" : "active",
                  on: { click: _vm.openTab }
                },
                [
                  _c("i", { staticClass: "el-icon-circle-plus" }),
                  _c("span", { staticClass: "word" }, [_vm._v("附属材料  ")]),
                  _c("i", {
                    class: _vm.drawerShow
                      ? "el-icon-arrow-left"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]
          ),
          _c(
            "el-main",
            { staticClass: "main-content", style: { height: _vm.boxHeight } },
            [
              _c("contract-view", {
                ref: "contractView",
                attrs: {
                  "contract-info": _vm.currentInfo,
                  "chapter-list": _vm.chapteJson,
                  items: _vm.contractInfoTemporary.items,
                  page: _vm.currentInfo.page,
                  scaleValue: _vm.scaleValue,
                  targetId: _vm.contractInfoTemporary.targetId,
                  "show-chapter": true,
                  isDetail: true,
                  "signatory-json": _vm.signatoryJson
                },
                on: {
                  "update:contractInfo": function($event) {
                    _vm.currentInfo = $event
                  },
                  "update:contract-info": function($event) {
                    _vm.currentInfo = $event
                  },
                  "update:chapterList": function($event) {
                    _vm.chapteJson = $event
                  },
                  "update:chapter-list": function($event) {
                    _vm.chapteJson = $event
                  },
                  "update:scaleValue": function($event) {
                    _vm.scaleValue = $event
                  },
                  "update:scale-value": function($event) {
                    _vm.scaleValue = $event
                  },
                  "del-chapte": function($event) {
                    return _vm.delChapteByCindex($event)
                  },
                  "pre-page": function($event) {
                    return _vm.getContractDetailByNum($event)
                  },
                  "next-page": function($event) {
                    return _vm.getContractDetailByNum($event)
                  },
                  changeSmallMap: _vm.changeSmallMap,
                  toCurrentPage: _vm.toCurrentPage
                }
              }),
              _c(
                "div",
                { staticClass: "contract-bottom" },
                [
                  _vm.contractInfoTemporary &&
                  _vm.contractInfoTemporary.items &&
                  _vm.contractInfoTemporary.items > 1
                    ? [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "text-align": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.currentInfo.page) +
                                "/" +
                                _vm._s(_vm.contractInfoTemporary.items) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: { effect: "light", placement: "left-start" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v("回到首页")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "jumpFirst",
                                on: {
                                  click: function($event) {
                                    return _vm.goPageAndFixed(1)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../assets/images/btn-down.png")
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { effect: "light", placement: "left" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v("上一页")]
                            ),
                            _c("span", {
                              staticClass: "el-icon-arrow-up prev_next_span",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(
                                    _vm.currentInfo.page > 1
                                      ? _vm.currentInfo.page - 1
                                      : 1
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { effect: "light", placement: "left" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v("下一页")]
                            ),
                            _c("span", {
                              staticClass: "el-icon-arrow-down prev_next_span",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(
                                    _vm.contractInfoTemporary.items >
                                      _vm.currentInfo.page
                                      ? _vm.currentInfo.page + 1
                                      : _vm.contractInfoTemporary.items
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { effect: "light", placement: "left-end" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v("回到尾页")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "jumpLast",
                                on: {
                                  click: function($event) {
                                    return _vm.goPageAndFixed(
                                      _vm.contractInfoTemporary.items
                                    )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../assets/images/btn-down.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-aside",
            {
              staticClass: "aside-right",
              style: { height: _vm.boxHeight },
              attrs: { width: "2.80rem" }
            },
            [
              _c(
                "div",
                { staticClass: "right-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.contractInfoTemporary &&
                            _vm.contractInfoTemporary.items &&
                            _vm.contractInfoTemporary.items > 1 &&
                            (_vm.beWord(_vm.fileList[_vm.checkAct].fileName) ||
                              (_vm.fileList[_vm.checkAct].useTo &&
                                _vm.fileList[_vm.checkAct].useTo === 1)) &&
                              !_vm.$route.query.multiFileKey,
                          expression:
                            "\n             contractInfoTemporary &&\n              contractInfoTemporary.items &&\n              contractInfoTemporary.items > 1 &&\n                  ((beWord(fileList[checkAct].fileName) ||\n                    (fileList[checkAct].useTo &&\n                      fileList[checkAct].useTo === 1)) &&\n                  !$route.query.multiFileKey)\n                "
                        }
                      ],
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.InOnlyOffice(
                            _vm.fileList[_vm.checkAct],
                            _vm.checkAct
                          )
                        }
                      }
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.backDraftFn()
                        }
                      }
                    },
                    [_vm._v("回到草稿箱")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.inviteReview()
                        }
                      }
                    },
                    [_vm._v("继续邀请他人进行审阅")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.getUpFiles(_vm.checkAct)
                        }
                      }
                    },
                    [_vm._v("刷新合同")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.backStep }
                    },
                    [_vm._v("终止审阅并发起")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("editor-pup", {
        attrs: { showofficeEditor: _vm.showofficeEditor, editor: _vm.editor },
        on: {
          "update:showofficeEditor": function($event) {
            _vm.showofficeEditor = $event
          },
          "update:showoffice-editor": function($event) {
            _vm.showofficeEditor = $event
          },
          saveLoading: _vm.saveLoading
        }
      }),
      _c("cooper-pup", {
        attrs: {
          cooperVisi: _vm.cooperVisi,
          darfPhoneList: _vm.coEditingInfos
        },
        on: {
          "update:cooperVisi": function($event) {
            _vm.cooperVisi = $event
          },
          "update:cooper-visi": function($event) {
            _vm.cooperVisi = $event
          },
          saveAndJump: _vm.continueReview
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe420272", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe420272","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/cooperateWith/toCreate.vue
// module id = wRmF
// module chunks = 2 6